import React from 'react';

export interface BarSegment {
  color: string;
  /** Width as a percentage of the bar (0–100). */
  percent: number;
}

interface SegmentedBarProps {
  segments: BarSegment[];
  /** Bar height in px. Default 10. */
  height?: number;
  /** Gap in px between segments. When > 0, each segment is its own rounded pill.
   *  When 0 (default), segments share a single rounded-full container with flat internal joins. */
  gap?: number;
  className?: string;
  style?: React.CSSProperties;
  ariaLabel?: string;
}

const SegmentedBar = ({
  segments,
  height = 10,
  gap = 0,
  className = '',
  style,
  ariaLabel,
}: SegmentedBarProps) => {
  if (gap > 0) {
    return (
      <div
        className={`flex w-full ${className}`}
        style={{ height, gap, ...style }}
        role="img"
        aria-label={ariaLabel}
      >
        {segments.map((seg, i) =>
          seg.percent > 0 ? (
            <div
              key={i}
              className="h-full"
              style={{
                width: `${seg.percent}%`,
                minWidth: 12,
                backgroundColor: seg.color,
                borderRadius: 20,
              }}
            />
          ) : null,
        )}
      </div>
    );
  }

  return (
    <div
      className={`overflow-hidden rounded-full flex w-full ${className}`}
      style={{ height, ...style }}
      role="img"
      aria-label={ariaLabel}
    >
      {segments.map((seg, i) => (
        <span
          key={i}
          style={{
            width: `${seg.percent}%`,
            background: seg.color,
            display: 'block',
          }}
        />
      ))}
    </div>
  );
};

export default SegmentedBar;
